<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-06 18:12:03
 * @Description: 账号安全 账号设置 手机号
-->
<template>
	<div class="set_mobile">
		<Head :title="$t('home.account_set.mobile')" />

		<a-form-model :model="form" :rules="rules" ref="form" :wrapper-col="{ span: 16, offset: 4 }">
			<a-form-model-item label="" prop="mobile">
				<a-select v-model="form.type">
					<a-select-option value="1">{{ $t("base.mobile.china") }}+86</a-select-option>
				</a-select>
				<a-input v-model="form.mobile" :placeholder="$t('base.mobile.placeholder')" />
			</a-form-model-item>
			<a-form-model-item label="" prop="code" class="flex">
				<a-input v-model="form.code" :placeholder="$t('base.captcha.placeholder')" />
				<div class="codeBox">
					<a-button v-if="count == 60" type="primary" @click="handleCode">{{ $t("base.btn.get_code") }}</a-button>
					<a-button type="primary" disabled v-else>{{ count }}s</a-button>
				</div>
			</a-form-model-item>
		</a-form-model>
	</div>
</template>

<script>
import Head from "./components/Head";
import { commonAPI } from "@/apis";

export default {
	components: { Head },
	props: {
		selfMobile: { type: String, default: "" },
	},
	data() {
		return {
			form: { type: "1", mobile: "", code: "" },
			rules: {
				mobile: [
					{ required: true, message: this.$t("base.mobile.placeholder") },
					{ pattern: /^1[3456789]\d{9}$/, message: this.$t("base.mobile.error_tip") },
				],
				code: [{ required: true, message: this.$t("base.captcha.placeholder") }],
			},
			count: 60,
		};
	},
	created() {
		this.form.mobile = this.selfMobile;
	},
	methods: {
		// 获取验证码
		async handleCode() {
			this.$refs.form.validateField("mobile", (message) => {
				if (!message) {
					let params = { noticeClassify: 2, businessClassify: "change_phone_email", account: this.form.mobile };
					this.handleVerify(params);
				} else {
					return false;
				}
			});
		},
		async handleVerify(params) {
			const { code, message } = await commonAPI.postAction("/send/msg/bindPhone", params);
			if (code == 0) {
				this.$message.success(message);
				// 开启倒计时
				this.count--;
				const timer = setInterval(() => {
					if (this.count > 0 && this.count <= 60) {
						this.count--;
					} else {
						this.count = 60;
						clearInterval(timer);
					}
				}, 1000);
			} else {
				this.$message.error(message);
			}
		},
	},
};
</script>

<style lang="less" scoped>
.set_mobile::v-deep {
	.ant-form-item-children {
		display: flex;
		align-items: center;
		.ant-select {
			width: 130px;
			margin-right: 10px;
		}

		.ant-input {
			flex: 1;
		}

		.codeBox {
			width: 100px;
			margin-left: 12px;
			& > * {
				width: 100%;
			}
		}
	}
}
</style>
